/* eslint-disable object-curly-newline */
/* eslint-disable prefer-object-spread */
/* eslint-disable no-undef */
/* eslint-disable comma-dangle */
import { takeLatest, call, put, all } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import api from '~/services/api';
import {
  updateProfileSuccess,
  updateProfileFailure,
  notShowChallengeVideoSuccess,
  notShowChallengeVideoFailure,
} from './actions';

export function* updateProfile({ payload }) {
  try {
    const { firstName, lastName, email, city, state, password, id } = payload;

    const response = yield call(api.put, `users/${id}`, {
      firstName,
      lastName,
      email,
      city,
      state,
      password,
    });

    toast.success('Perfil atualizado com sucesso!');

    yield put(updateProfileSuccess(response.data));
  } catch (error) {
    toast.error('Erro ao atualizar perfil, confira seus dados!');

    yield put(updateProfileFailure());
  }
}

export function* notShowVideoChallenge({ payload }) {
  try {
    const { status } = payload;
    const response = yield call(api.put, 'notshowvideochallenge', { status });

    toast.success('Nāo iremos mais mostrar esse tutorial pra você');

    yield put(notShowChallengeVideoSuccess(response.data));
  } catch (error) {
    toast.error('Algo deu errado, tente novamente.');
    yield put(notShowChallengeVideoFailure());
  }
}

export default all([
  takeLatest('@user/UPDATE_PROFILE_REQUEST', updateProfile),
  takeLatest('@user/NOT_SHOW_CHALLENGE_VIDEO_REQUEST', notShowVideoChallenge),
]);
